export default __webpack_public_path__ + "static/media/🎉.4a37cabb.svg";